import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectCrossLinks } from '../../../common/selectors/crossLinks/selectCrossLinks';
import { SeoCrossLinks } from '../../components/SeoCrossLinks';

export function SeoCrossLinksContainer() {
  const crossLinks = useSelector(selectCrossLinks);

  if (!crossLinks?.length) {
    return null;
  }

  return <SeoCrossLinks seoBlocks={crossLinks} />;
}
